import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerSearchParams } from 'app/ts/params/CustomerSearchParams';
import { AppPaths } from './app-paths';

/**
 * Moving forward this should be the preferred
 * method of navigating in the application.
 */
@Injectable({
  providedIn: 'root',
})
export class NavigateService {
  constructor(private router: Router) {}

  public home(): void {
    this.router.navigate([AppPaths.Home]);
  }

  public customers(query: object): void {
    let url = `${AppPaths.Customers}?${this.asQueryString(query)}`;
    this.router.navigateByUrl(url);
  }

  public deliveryAddresses(query: object): void {
    let url = `${AppPaths.DeliveryAddresses}?${this.asQueryString(query)}`;
    this.router.navigateByUrl(url);
  }

  public floorPlan(
    floorPlanId: number,
    extra?: { [k: string]: any },
    isLegacy: boolean = false,
  ): void {
    let url = `${AppPaths.FloorPlan}/${isLegacy ? 'o-' : ''}${floorPlanId}`;
    this.router.navigateByUrl(url, {
      state: extra,
    });
  }

  public floorPlans(query: CustomerSearchParams): void {
    let url = `${AppPaths.FloorPlans}?${this.asQueryString(query)}`;
    this.router.navigateByUrl(url);
  }

  public projects(query: object): void {
    let url = `${AppPaths.Projects}?${this.asQueryString(query)}`;
    this.router.navigateByUrl(url);
  }

  public to(path: string, query?: object) {
    let url: string = path;
    if (query != null) {
      url = url + `?${this.asQueryString(query)}`;
    }
    this.router.navigateByUrl(url);
  }

  /**
   * Changes the query string without actively navigating
   * @param query
   */
  public setQuery(queryParams: object, currentRoute: ActivatedRoute) {
    this.router.navigate([], {
      relativeTo: currentRoute,
      queryParams: queryParams,
      skipLocationChange: false,
      replaceUrl: true,
      preserveFragment: true,
    });
  }

  private asQueryString(params: object): string {
    const searchParams = new URLSearchParams('');

    for (const [key, value] of Object.entries(params)) {
      if (value != null) {
        searchParams.set(key, value.toString());
      }
    }

    return searchParams.toString();
  }
}
